import { ReactNode } from 'react';
import { FluentProvider } from '@fluentui/react-components';
import { viaeroLightTheme } from 'theme';
import { MainContextProvider } from 'contexts/MainContext/MainContext.provider';
import { CartContextProvider } from './contexts/CartContext/CartContext.provider';
import { LineEditContextProvider } from 'contexts/LineEditContext/LineEditContext.provider';
import { PaymentContextProvider } from 'contexts/PaymentContext/PaymentContext.provider';

const Providers = (props: { children: ReactNode }) => (
    <div>
        <CartContextProvider>
            <PaymentContextProvider>
                <LineEditContextProvider>
                    <FluentProvider theme={viaeroLightTheme}>
                        <MainContextProvider>{props.children}</MainContextProvider>
                    </FluentProvider>
                </LineEditContextProvider>
            </PaymentContextProvider>
        </CartContextProvider>
    </div>
);

export default Providers;
